export function hashValue(value: unknown): string {
  if (value === null || value === undefined) {
    return "null";
  }

  try {
    return JSON.stringify(value);
  } catch {
    console.warn("Failed to hash value", value);
    return "";
  }
}
